import { $generateNodesFromDOM } from '@lexical/html';
import { TextMatchTransformer } from '@lexical/markdown';
import { $isTableNode, TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { LexicalEditor, LexicalNode } from 'lexical';
import { cleanTableHTML } from '../../../utils/cleanTableHTML';
import { exportNodeToDOM } from '../../../utils/exportNodesToDOM';
import { isHtmlOrigin, markAsHtmlOrigin } from '../../../utils/tableOrigin';

export const createInlineTableTransformer = (editor: LexicalEditor): TextMatchTransformer => ({
  type: 'text-match',
  dependencies: [TableNode, TableCellNode, TableRowNode],

  regExp: /<table(?:\s[^>]*)?>[\s\S]*?<\/table>/i,
  importRegExp: /<table(?:\s[^>]*)?>[\s\S]*?<\/table>/i,

  export: (node: LexicalNode) => {
    if (!$isTableNode(node) || !isHtmlOrigin(node)) {
      return null;
    }

    const element = exportNodeToDOM(node, editor);
    if (!element) {
      return null;
    }

    const container = document.createElement('div');
    container.appendChild(element);
    cleanTableHTML(container);

    return container.innerHTML;
  },

  replace: textNode => {
    const tableHtml = textNode.getTextContent();
    const parser = new DOMParser();
    const doc = parser.parseFromString(tableHtml, 'text/html');
    const nodes = $generateNodesFromDOM(editor, doc);

    if (nodes.length === 0) {
      return;
    }

    const firstNode = nodes[0];
    markAsHtmlOrigin(firstNode);
    textNode.replace(firstNode);

    for (let i = 1; i < nodes.length; i++) {
      markAsHtmlOrigin(nodes[i]);
      firstNode.insertAfter(nodes[i]);
    }
  },
});
